module.exports = __webpack_public_path__ + "img/credit_black.aad07085.svg";